import { render, staticRenderFns } from "./next-page.vue?vue&type=template&id=1d5092bf"
var script = {}
import style0 from "./next-page.vue?vue&type=style&index=0&id=1d5092bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports